import { animateCSS } from "./animate_css"
import { setAnimationSpeed } from "./set_animation_speed"

export const fadeOut = async (el, speed) => {
  setAnimationSpeed(el, speed)
  await animateCSS(el, 'fadeOut')
  return el.style.display = 'none'
}
